import React, { Component } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';

// QR Orders: one collapsible row per QR order (requestid) whose lines are at
// statusId 15 — "confirmed by customer" — expand to see its menu items and
// dispatch selected ones to the kitchen (statusId 15 -> 11). Collapsed by default so a long list of
// waiting orders stays scannable; expand state is local to this modal, not
// lifted to CaptainDashboard. Selection itself (and the two "select all"
// levels — one order, or every order) lives in CaptainDashboard so a
// selection survives collapsing/expanding a row.
class PendingItemsModal extends Component {

    state = { expandedIds: [] };

    toggleExpanded = (requestId) => {
        this.setState(prev => ({
            expandedIds: prev.expandedIds.includes(requestId)
                ? prev.expandedIds.filter(id => id !== requestId)
                : [...prev.expandedIds, requestId],
        }));
    };

    renderOrder = (group) => {
        const { onToggleItem, onToggleOrder, onSendToKitchen } = this.props;
        const expanded = this.state.expandedIds.includes(group.requestId);
        const hasSelected = group.items.some(it => it.selected);
        const allSelected = group.items.length > 0 && group.items.every(it => it.selected);

        return (
            <div className="captain-pending-order" key={group.requestId}>
                <button
                    type="button"
                    className="captain-pending-order-header"
                    onClick={() => this.toggleExpanded(group.requestId)}
                    aria-expanded={expanded}
                >
                    <i className={`pi ${expanded ? 'pi-chevron-down' : 'pi-chevron-right'}`} />
                    <span className="captain-pending-order-label">{group.label}</span>
                    {group.tableNo && <span className="captain-pending-order-meta">Table {group.tableNo}</span>}
                    <span className="captain-pending-order-count">
                        {group.items.length} item{group.items.length !== 1 ? 's' : ''}
                    </span>
                </button>

                {expanded && (
                    <div className="captain-pending-order-body">
                        <label
                            className="captain-kot-item-check captain-pending-select-all"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <input
                                type="checkbox"
                                checked={allSelected}
                                onChange={(e) => onToggleOrder(group, e.target.checked)}
                            />
                            Select All
                        </label>

                        <div className="captain-kot-items">
                            {group.items.map(item => (
                                <label key={item.id} className="captain-kot-item-check captain-pending-item">
                                    <input
                                        type="checkbox"
                                        checked={item.selected}
                                        onChange={(e) => onToggleItem(item.id, e.target.checked)}
                                    />
                                    <span className="captain-kot-item-qty">&times;{item.qty}</span>
                                    <span className="captain-kot-item-name">{item.name}</span>
                                </label>
                            ))}
                        </div>

                        <Button
                            label="Send Selected to Kitchen"
                            icon="pi pi-send"
                            className="p-button-success captain-kot-mark-ready"
                            disabled={!hasSelected}
                            onClick={() => onSendToKitchen(group.items)}
                        />
                    </div>
                )}
            </div>
        );
    };

    render() {
        const {
            visible, onHide, groups = [], onToggleAll, onSendToKitchen,
            dateRange, onDateRangeChange,
            // The same modal serves QR Orders and Scheduled Orders.
            title = 'QR Orders — Confirmed by Customer',
            emptyText = 'No pending items waiting right now.',
        } = this.props;
        const allItems = groups.flatMap(g => g.items);
        const selectedCount = allItems.filter(it => it.selected).length;
        const allSelected = allItems.length > 0 && selectedCount === allItems.length;

        return (
            <Dialog
                header={title}
                visible={visible}
                onHide={onHide}
                className="captain-pending-modal"
                style={{ width: '520px' }}
                dismissableMask
            >
                <div className="captain-pending-date-filter">
                    <label htmlFor="captain-pending-date-range">
                        <i className="pi pi-calendar" /> Delivery date
                    </label>
                    <Calendar
                        inputId="captain-pending-date-range"
                        value={dateRange}
                        onChange={(e) => onDateRangeChange(e.value)}
                        selectionMode="range"
                        dateFormat="dd/mm/yy"
                        showIcon
                        readOnlyInput
                        placeholder="Select date range"
                        // The Dialog clips its content's overflow, which cuts off the
                        // calendar's dropdown panel when rendered inline — appendTo
                        // portals the panel onto <body> instead so it floats above
                        // the dialog uncropped.
                        appendTo={document.body}
                    />
                </div>

                {groups.length === 0 ? (
                    <div className="captain-kot-empty">{emptyText}</div>
                ) : (
                    <>
                        <div className="captain-pending-select-all-row">
                            <label className="captain-kot-item-check">
                                <input
                                    type="checkbox"
                                    checked={allSelected}
                                    onChange={(e) => onToggleAll(groups, e.target.checked)}
                                />
                                Select All Orders
                            </label>

                            <span className="captain-pending-selected-count">{selectedCount} selected</span>

                            <Button
                                label="Send Selected to Kitchen"
                                icon="pi pi-send"
                                className="p-button-success"
                                disabled={selectedCount === 0}
                                onClick={() => onSendToKitchen(allItems)}
                            />
                        </div>

                        <div className="captain-pending-order-list">
                            {groups.map(this.renderOrder)}
                        </div>
                    </>
                )}
            </Dialog>
        );
    }
}

export default PendingItemsModal;
